import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accentColor", "inWelcomeMessage", "children", "onClick"];
import styled from 'styled-components';
import { getCanReadTextOnce } from 'visitor-ui-component-library/utils/colors';
import { OBSIDIAN, NEUTRAL_500, NEUTRAL_800, NEUTRAL_900, WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { promptButtonBaseStyles } from '../shared/components/BasePromptButton';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickReplyButtonStyled = styled.button.withConfig({
  displayName: "QuickReplyButton__QuickReplyButtonStyled"
})(["", " background:", ";color:", ";border:1px solid ", ";cursor:pointer;&:hover:not(:disabled){color:", ";border-color:", ";}&:disabled{opacity:0.6;cursor:not-allowed;}"], promptButtonBaseStyles, WHITE, OBSIDIAN, ({
  $borderColor
}) => $borderColor, ({
  $accentColor
}) => $accentColor || NEUTRAL_900, ({
  $accentColor
}) => $accentColor || NEUTRAL_900);
const QuickReplyButton = _ref => {
  let {
      accentColor,
      inWelcomeMessage = false,
      children,
      onClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isTextReadable = getCanReadTextOnce(accentColor);
  const accessibleAccentColor = isTextReadable ? accentColor : OBSIDIAN;
  const borderColor = inWelcomeMessage ? NEUTRAL_500 : NEUTRAL_800;
  return /*#__PURE__*/_jsx(QuickReplyButtonStyled, Object.assign({
    $accentColor: accessibleAccentColor,
    $borderColor: borderColor,
    onClick: onClick
  }, props, {
    children: children
  }));
};
QuickReplyButton.displayName = 'QuickReplyButton';
export default QuickReplyButton;